import { RefObject, useEffect, useRef, useState } from "react";

export interface Dimensions {
  width: number;
  height: number;
}

/**
 * Takes in a HTML Element and sets up a ResizeObserver on the element to return the element's size as it updates.
 * Only HTML Element's are observable, and not SVG Elements */
export const useElementResponsiveDimensions = <T extends HTMLElement>(ref: RefObject<T>) => {
  const [dimensions, setDimensions] = useState<Dimensions>({ width: 0, height: 0 });

  // set up new resize observer that gets the element content rect and updates the dimension state
  const observer = useRef(
    new ResizeObserver((entries) => {
      const contentRect = entries[0]?.contentRect;
      const width: number = contentRect?.width || 0;
      const height: number = contentRect?.height || 0;

      setDimensions({ width, height });
    })
  );

  useEffect(() => {
    const refElement = ref.current;
    const currentObserver = observer.current;

    // observe input element size
    if (refElement) {
      currentObserver.observe(refElement);
    }

    // cleanup observer on rerun
    return () => {
      if (refElement) currentObserver.unobserve(refElement);
    };
  }, [ref]);

  return dimensions;
};
